module.exports = __webpack_public_path__ + "media/images/weather/240_day-94a8ab8a76144c7f779ba1e282eb2cb4.png";